<script lang="ts">
  // Render children only once the placeholder is near the viewport (saves fetching/parsing maps below the fold).
  import type { Snippet } from 'svelte';
  let { children, height = 400, onvisible }: { children: Snippet; height?: number; onvisible?: () => void } = $props();
  let el: HTMLDivElement | undefined = $state();
  let seen = $state(typeof IntersectionObserver === 'undefined');
  $effect(() => { if (seen) onvisible?.(); });
  $effect(() => {
    if (seen || !el) return;
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { seen = true; io.disconnect(); } }, { rootMargin: '600px 0px' });
    io.observe(el);
    return () => io.disconnect();
  });
</script>

{#if seen}{@render children()}{:else}<div bind:this={el} class="skel" style="height:{height}px" aria-hidden="true"></div>{/if}
